export const getRuleSizeAndLength = (limit: number, message: string) => {
  const prepareMessage = message.replace("{{limit}}", String(limit));

  return {
    value: limit,
    message: prepareMessage,
  };
};
